<script setup lang="ts">
import OfficeNavigation from '@/office/components/OfficeNavigation.vue';
import { gaiaBaseTextSize } from '@/components/design/themes/tokens';
import { useAuthenticatedBootstrap } from '@/composables/useAuthenticatedBootstrap';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

useAuthenticatedBootstrap();

// Same body size as the web shell (layout/Layout.vue): components inside name
// a role from the type scale, anything that doesn't ask inherits this.
const baseTextSize = gaiaBaseTextSize;
</script>

<template>
  <!-- The Word task pane: a header with the mark, the routed page, and the
       bottom navigation OfficeNavigation pins. The content's bottom padding
       is what keeps the last row clear of that bar. -->
  <n-layout position="absolute" class="office-addin-layout" :style="{ fontSize: baseTextSize }">
    <office-navigation v-if="authStore.isAuthenticated" />
    <n-layout-content content-style="padding: 14px 12px 76px;">
      <router-view />
    </n-layout-content>
  </n-layout>
</template>

<style scoped>
:deep(.n-layout-content) {
  background-color: var(--body-color);
}
</style>
